<template>

    <div id='crazetrip' class='page-projects'>
        <go-back/>

        <h6 class='heading'>crazetrip</h6>
        <img src="/img/projects/crazetrip.jpg" alt="">
        <section class='p-intro'>
            <div class="row">
                <div class="col">
                    <ul class='list4'>
                        <li><p>YEAR</p>2018</li>
                        <li><p>COMPANY</p>Crazetrip</li>
                        <li><p>ROLE</p>WEB CODER / WEB DESIGN</li>
        
                    </ul>
                </div>
                <div class="col">
                     <p>CrazeTrip is a website that promotes the unseen and unheard places of the Philippines. They believe in making a difference and pledge to donate 10% of their profits to the less privileged children in the Philippines so that they can enjoy better living standards and education. .</p>
                </div>
            </div>
               
            <hr>
                

        </section>
        <section class='p-content'>

            <img src="/img/projects/ct1.jpg" alt="">
            <img src="/img/projects/ct2.jpg" alt="">
            <img src="/img/projects/ct3.jpg" alt="">
            <img src="/img/projects/ct6.jpg" alt="">
           
         
           
        </section>
        <section class='p-footer'>
            <div class="row">
                <div class="col"> 
                    <video autoplay loop muted>
                        <source src="/video/2.mp4" type="video/mp4">Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <div class="row">
                
                <div class="col">
                    <div class='device-preview'>
                        <div><img src="/img/projects/ct5.jpg" alt="mobile-preview"></div>
                    </div>
                    <img src="/img/projects/ct4.jpg" alt="" style='width:400px;'>
                </div>
               
            </div>
         
             
            
        </section>
      
            <a href="#crazetrip" class='link2'>Top</a>

            <a href="http://www.crazetrip.com/" class='link2'>Visit Website </a>
            
            <a href="https://www.facebook.com/CrazeTrip/" class='link2'>Facebook</a>
    
            <p class="">
                *Possible unavailable or content have been changed<br>
                <br>
            </p>
    
            
            <router-link to="/projects" class='link2'>ALL PROJECTS</router-link>
       

    </div>
</template>


<script>
import GoBack from '@/components/GoBack'
export default {
    components: {
        GoBack
    }
}
</script>

<style lang="scss">
.page-projects {
    padding:5vh;
    overflow: hidden;
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    img {
        width: 100%;
        height: auto;
   
    }
    .p-intro {
        display: flex;
        flex-direction: column;
     
        
    }

    section {
        padding:10% 0;
    }
    
    video{
        width: 100%;
    }
    p {
        padding:20px 0;
    }
}

.device-preview { // display none mobikle
    background-image: url(/img/projects/mobile.svg);
    background-size: 100% auto;
    display: block;
    height: 463px;
    width: 261px;
    //border-radius: 55px 55px 0 0;
    //box-shadow: 30px 20px 6px rgba(0,0,0,.2);
    margin: 0 auto;
    padding: 75px 19px 76px 19px;
    cursor:none;
    div {
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        height: 100%;
    }
}
</style>